export const dataTestId = (testId: string) =>
  `consolidated-shipping-explainer-${testId}`
